import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const AdminClubRunningTrack = ({
    selectClubInfo,
    setRunningTrackFlag,
    setChangeRunningTrackInfo,
}) => {
    const onChangeCouponFlag = (e)=>{
        setRunningTrackFlag(parseInt(e.target.value))
    }
  return selectClubInfo ? (
    <SettingCard title="제타트랙">
        <SettingInfoBox>
            <SettingInfoLabel>활성화 유무</SettingInfoLabel>
            <SettingInfoValue>
                <RadioGroup
                    aria-label="type"
                    name="viewType"
                    value={selectClubInfo.runningTrack}
                    onChange={onChangeCouponFlag}
                    row={true}
                >
                    <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="활성화"
                    />
                    <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="비활성화"
                    />
                </RadioGroup>
            </SettingInfoValue>
        </SettingInfoBox>
        <CardFooter>
            <SaveButton active={selectClubInfo.isEdit} onClick={() => setChangeRunningTrackInfo()}>
                수정하기
            </SaveButton>
        </CardFooter>
    </SettingCard>
  ) : null;
};

export default React.memo(AdminClubRunningTrack);
